import { useTranslation } from "react-i18next";

export const TermsAndConditions = () => {
  const { t } = useTranslation();

  return (
    <section className="bg-white pt-32 px-[5%] sm:px-[3%] md:pt-40 pb-28 md:pb-40">
      <div className="w-full max-w-[80rem] mx-auto space-y-12">
        <div className="space-y-6">
          <h2 className="text-2xl/tight lg:text-3xl/tight font-bold">
            {t("terms.title")}
          </h2>
          <p className="text-base/relaxed lg:text-lg/relaxed text-gray-400">
            {t("terms.lastUpdate")}
          </p>
          <p className="text-base/relaxed lg:text-lg/relaxed text-gray-400">
            {t("terms.introduction")}
          </p>
        </div>

        <div className="space-y-4">
          <h3 className="text-xl font-bold">
            {t("terms.sections.service.title")}
          </h3>
          <p className="text-base/relaxed lg:text-lg/relaxed text-gray-400">
            {t("terms.sections.service.content")}
          </p>
        </div>

        <div className="space-y-4">
          <h3 className="text-xl font-bold">
            {t("terms.sections.usage.title")}
          </h3>
          <ol className="list-outside list-disc pl-5 text-gray-400 space-y-2">
            <li className="text-base/relaxed lg:text-lg/relaxed">
              <span className="font-bold">{t("terms.sections.usage.registration.title")}: </span>
              {t("terms.sections.usage.registration.content")}
            </li>
            <li className="text-base/relaxed lg:text-lg/relaxed">
              <span className="font-bold">{t("terms.sections.usage.userResponsibility.title")}: </span>
              {t("terms.sections.usage.userResponsibility.content")}
            </li>
          </ol>
        </div>

        <div className="space-y-4">
          <h3 className="text-xl font-bold">
            {t("terms.sections.yoshiCard.title")}
          </h3>
          <ol className="list-outside list-disc pl-5 text-gray-400 space-y-2">
            <li className="text-base/relaxed lg:text-lg/relaxed">
              <span className="font-bold">{t("terms.sections.yoshiCard.items.obtaining.title")}: </span>
              {t("terms.sections.yoshiCard.items.obtaining.content")}
            </li>
            <li className="text-base/relaxed lg:text-lg/relaxed">
              <span className="font-bold">{t("terms.sections.yoshiCard.items.usage.title")}: </span>
              {t("terms.sections.yoshiCard.items.usage.content")}
            </li>
            <li className="text-base/relaxed lg:text-lg/relaxed">
              <span className="font-bold">{t("terms.sections.yoshiCard.items.balance.title")}: </span>
              {t("terms.sections.yoshiCard.items.balance.content")}
            </li>
          </ol>
        </div>

        <div className="space-y-4">
          <h3 className="text-xl font-bold">
            {t("terms.sections.refunds.title")}
          </h3>
          <ol className="list-outside list-disc pl-5 text-gray-400 space-y-2">
            <li className="text-base/relaxed lg:text-lg/relaxed">
              <span className="font-bold">{t("terms.sections.refunds.items.request.title")}: </span>
              {t("terms.sections.refunds.items.request.content")}
            </li>
            <li className="text-base/relaxed lg:text-lg/relaxed">
              <span className="font-bold">{t("terms.sections.refunds.items.method.title")}: </span>
              {t("terms.sections.refunds.items.method.content")}
            </li>
            <li className="text-base/relaxed lg:text-lg/relaxed">
              <span className="font-bold">{t("terms.sections.refunds.items.process.title")}: </span>
              {t("terms.sections.refunds.items.process.content")} <a 
                href="https://yoshicash.com/refunds" 
                className="underline hover:text-gray-300 transition-colors"
              >
                yoshicash.com/refunds
              </a>
            </li>
            <li className="text-base/relaxed lg:text-lg/relaxed">
              <span className="font-bold">{t("terms.sections.refunds.items.processingTime.title")}: </span>
              {t("terms.sections.refunds.items.processingTime.content")}
            </li>
            <li className="text-base/relaxed lg:text-lg/relaxed">
              <span className="font-bold">{t("terms.sections.refunds.items.conditions.title")}: </span>
              {t("terms.sections.refunds.items.conditions.content")}
            </li>
          </ol>
        </div>

        <div className="space-y-4">
          <h3 className="text-xl font-bold">
            {t("terms.sections.payments.title")}
          </h3>
          <ol className="list-outside list-disc pl-5 text-gray-400 space-y-2">
            <li className="text-base/relaxed lg:text-lg/relaxed">
              <span className="font-bold">{t("terms.sections.payments.items.acceptedMethods.title")}: </span>
              {t("terms.sections.payments.items.acceptedMethods.content")}
            </li>
            <li className="text-base/relaxed lg:text-lg/relaxed">
              <span className="font-bold">{t("terms.sections.payments.items.security.title")}: </span>
              {t("terms.sections.payments.items.security.content")}
            </li>
          </ol>
        </div>

        <div className="space-y-4">
          <h3 className="text-xl font-bold">
            {t("terms.sections.liability.title")}
          </h3>
          <ol className="list-outside list-disc pl-5 text-gray-400 space-y-2">
            <li className="text-base/relaxed lg:text-lg/relaxed">
              {t("terms.sections.liability.items.0")}
            </li>
            <li className="text-base/relaxed lg:text-lg/relaxed">
              {t("terms.sections.liability.items.1")}
            </li>
          </ol>
        </div>

        <div className="space-y-4">
          <h3 className="text-xl font-bold">
            {t("terms.sections.modifications.title")}
          </h3>
          <ol className="list-outside list-disc pl-5 text-gray-400 space-y-2">
            <li className="text-base/relaxed lg:text-lg/relaxed">
              {t("terms.sections.modifications.items.0")}
            </li>
            <li className="text-base/relaxed lg:text-lg/relaxed">
              {t("terms.sections.modifications.items.1")}
            </li>
          </ol>
        </div>

        <div className="space-y-4">
          <h3 className="text-xl font-bold">
            {t("terms.sections.intellectualProperty.title")}
          </h3>
          <ol className="list-outside list-disc pl-5 text-gray-400">
            <li className="text-base/relaxed lg:text-lg/relaxed">
              {t("terms.sections.intellectualProperty.content")}
            </li>
          </ol>
        </div>

        <div className="space-y-4">
          <h3 className="text-xl font-bold">{t("terms.sections.law.title")}</h3>
          <ol className="list-outside list-disc pl-5 text-gray-400 space-y-2">
            <li className="text-base/relaxed lg:text-lg/relaxed">
              {t("terms.sections.law.items.0")}
            </li>
            <li className="text-base/relaxed lg:text-lg/relaxed">
              {t("terms.sections.law.items.1")}
            </li>
          </ol>
        </div>

        <div className="space-y-4">
          <h3 className="text-xl font-bold">
            {t("terms.sections.contact.title")}
          </h3>
          <p className="text-base/relaxed lg:text-lg/relaxed text-gray-400">
            {t("terms.sections.contact.introduction")}
          </p>
          <ol className="list-outside list-disc pl-5 text-gray-400 space-y-2">
            <li className="text-base/relaxed lg:text-lg/relaxed">
              <span className="font-bold">{t("terms.sections.contact.items.email.title")}: </span>
              {t("terms.sections.contact.items.email.content")}
            </li>
            <li className="text-base/relaxed lg:text-lg/relaxed">
              <span className="font-bold">{t("terms.sections.contact.items.whatsapp.title")}: </span>
              {t("terms.sections.contact.items.whatsapp.content")}
            </li>
            <li className="text-base/relaxed lg:text-lg/relaxed">
              <span className="font-bold">{t("terms.sections.contact.items.website.title")}: </span>
              {t("terms.sections.contact.items.website.content")}
            </li>
          </ol>
        </div>
      </div>
    </section>
  );
};
